/* Only merge CSS if running webpack */

// react-toastify tries do the inline CSS thing and it's all fubared if you use
// CSP (content security policies) on your server (like we do).
// We alias in the webpack config to an unstyled version of react-toastify.
// This just uses a regular CSS file, and then we
// override a bunch of stuff (in ./Toast.js) using styled-components.
// See https://github.com/fkhadra/react-toastify/issues/1209
// I had to use a new 'aliased-react-toastify' to get to the css in the normal
// location because I aliased the regular module :)
// eslint-disable-next-line import/no-unresolved
import 'aliased-react-toastify/dist/ReactToastify.css';
// eslint-disable-next-line import/extensions
import Toast from './Toast.js';
import ThemeComponentSwitcher from '../styling/ThemeComponentSwitcher';
import gl2025Toast from './Toast.gl2025';

let SwitchedComponent = ThemeComponentSwitcher([
    {
        theme: 'gl2025',
        component: gl2025Toast
    },
    { component: Toast }
]);

export default SwitchedComponent;
